// extracted by mini-css-extract-plugin
module.exports = {"deleteClubSection":"_yl9DGo7","deleteClubTitle":"_1iY4aj3","deleteClubInstructions":"_3SM4e3A","deleteClubEmail":"_39D3InS"};